const axios = require('axios')

module.exports = webhooksUrl => ({
    message: text => axios.post(webhooksUrl, { text }),
    richMessage: msg => axios.post(webhooksUrl, msg)
})



// WEBPACK FOOTER //
// ./src/libraries/slack.js